<template>
    <!--콘텐츠 영역-->
    <div class="mainbusiness_wrap">
        <div id="sub_contents" class="mainbusiness education">
            <div class="tit">
                <div>SONGWON FOUNDATION</div>
                <h3>주요사업</h3>
                <!-- <h3>송원문화재단은 2004년부터<br>
                    전국의 우수 이공계 장학생 선발을<br>
                    통해 장학금을 지원하고있습니다.
                </h3>
                <p>
                    이를 통해 대한민국의 우수한 인재를 양성하고 미래사회 일원으로 발돋움 할 수 있도록 돕고자합니다.<br>
                    또한 기업이익을 지역사회에 환원하고 부산시민의 은혜에 보답한다는 재단설립의 취지에따라,
                    생활형편이 어려운 학생의 장학금과 생활비를 지원하였습니다.
                </p> -->
            </div>
            <div class="edu_cont_wrap">
                <div class="edu_cont">
                    <div class="img_box"><img :src="require('./../../assets/img/sub/01/mainbusiness01.png')" /></div>
                    <div class="txt_box">
                        <h3>송원 공과대학 장학생</h3>
                        <p>
                            주요 대학 공학계열 전공 대학생을 선발하여 <strong>등록금 전액을 지원</strong>하고, 어학 및 자격시험 응시 비용을 지원합니다.<br>
                            또한 장학생이 졸업 후 <strong>동국그룹 대졸공채 또는 주니어사원 입사를 희망하는 경우 채용 과정에서 가점을 부여</strong>하여, 학업 지원을 넘어 학생들의 성장과 취업을 함께 지원합니다.
                        </p>
                    </div>
                </div>
                <div class="edu_cont">
                    <div class="img_box"><img :src="require('./../../assets/img/sub/01/mainbusiness02.png')" /></div>
                    <div class="txt_box">
                        <h3>송원 미래건축인재 펠로우십</h3>
                        <p>
                            전국의 건축계열 전공 대학생 및 졸업생을 대상으로 장학생을 선발하여, <strong>단순한 견학을 넘어 실제 현장과 프로젝트를 경험할 수 있는 실무형 교육 프로그램</strong>을 운영합니다. <br>
                            건축과 예술이 결합된 실제 프로젝트의 기획과 과정을 배우고, <strong>이를 자신만의 시선으로 기록하고 표현할 수 있는 기회</strong>를 제공합니다.
                        </p>
                    </div>
                </div>
                <div class="edu_cont multi_box">
                    <div class="left_col">
                        <div class="img_item">
                            <div class="img_box"><img :src="require('./../../assets/img/sub/01/mainbusiness03.png')" /></div>
                            <p class="sub_txt">부산국제영화제 어워드 시상</p>
                        </div>
                        <div class="img_item">
                            <div class="img_box"><img :src="require('./../../assets/img/sub/01/mainbusiness04.png')" /></div>
                            <p class="sub_txt">박윤정재단(에스모스서울) 장학금 지정기탁</p>
                        </div>
                    </div>
                    <div class="right_col">
                        <div class="txt_box">
                            <h3>교육학술후원</h3>
                            <p>
                                <strong>교육과 학술의 가치를 함께 실현하는 단체를 후원하고 협력함으로써, 더불어 성장하고 행복한 사회를 만들어가고자 합니다.</strong><br>
                                교육의 기회를 확대하고 학술 및 문화의 발전에 기여하는 다양한 단체와 함께하며, 각 단체가 추구하는 뜻깊은 활동이 지속적으로 이어질 수 있도록 지원합니다.<br>
                                개인의 배움과 성장을 넘어, <strong>좋은 뜻을 가진 사람들이 서로 연결되고 그 가치가 사회 곳곳으로 확산될 수 있도록</strong> 교육·학술 분야의 다양한 활동을 발굴하고 후원하겠습니다.
                            </p>
                        </div>
                        <div class="img_item">
                            <div class="img_box"><img :src="require('./../../assets/img/sub/01/mainbusiness05.png')" /></div>
                            <p class="sub_txt">캔파운데이션 '아트버스 캔버스' 프로젝트 후원</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        message: "Brochure.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/EducationSupport.vue